<ng-container
  [ngTemplateOutlet]="formatByCode?.alwaysAvailable ? alwaysAvailable : notAlwaysAvailable"
  [ngTemplateOutletContext]="{ nonCirc: materialTab?.availability?.nonCirculating }"/>

<ng-template #alwaysAvailable>
  <div class="status alwaysAvailable d-inline-flex"
       data-automation-id="rollup-tabs-content-status-container">
    <span class="available" translate>tabsAvailable</span>
  </div>
</ng-template>

<ng-template #notAlwaysAvailable let-nonCirc="nonCirc">
  <div [ngSwitch]="availabilityStatus"
       class="status d-inline-flex"
       data-automation-id="rollup-tabs-content-status-container">
    <ng-container *ngSwitchDefault
                  [ngTemplateOutlet]="unavailable" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.AVAILABLE"
                  [ngTemplateOutlet]="available" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.GET_ISSUES"
                  [ngTemplateOutlet]="available" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.GET_MATERIAL"
                  [ngTemplateOutlet]="available" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.ON_ORDER"
                  [ngTemplateOutlet]="onOrder" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.CHECKED_OUT"
                  [ngTemplateOutlet]="checkedOut" [ngTemplateOutletContext]="{ nonCirc }"/>
    <ng-container *ngSwitchCase="availabilityStatuses.CHECK_AVAILABILITY"
                  [ngTemplateOutlet]="checkAvailability" [ngTemplateOutletContext]="{ nonCirc }"/>
  </div>
</ng-template>

<ng-template #unavailable let-translationKey="nonCirc ? 'tabsInLibraryUseOnly' : 'tabsUnavailable'">
  <span class="unavailable" translate [attr.aria-label]="translationKey | translate">{{ translationKey }}</span>
</ng-template>

<ng-template #available let-translationKey="nonCirc ? 'tabsInLibraryUseOnly' : 'tabsAvailable'">
  <span class="available" translate [attr.aria-label]="translationKey | translate">{{ translationKey }}</span>
</ng-template>

<ng-template #onOrder let-translationKey="nonCirc ? 'tabsInLibraryUseOnly' : 'tabsOnOrder'">
  <span class="available" translate [attr.aria-label]="translationKey | translate">{{ translationKey }}</span>
</ng-template>

<ng-template #checkedOut let-translationKey="nonCirc ? 'tabsInLibraryUseOnly' : 'tabsCheckedOut'">
  <span class="checked-out" translate [attr.aria-label]="translationKey | translate">{{ translationKey }}</span>
</ng-template>

<ng-template #checkAvailability let-translationKey="nonCirc ? 'tabsInLibraryUseOnly' : 'tabsCheckAvailability'">
  <span class="check-availability" translate [attr.aria-label]="translationKey | translate">{{ translationKey }}</span>
</ng-template>
